import React, { Fragment } from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import LinkedInInactive from 'pages/pledgxOutputPDF/images/linkedInInactive.png'
import LinkedInActive from 'pages/pledgxOutputPDF/images/linkedInActive.png'
import ResumeActive from 'pages/pledgxOutputPDF/images/resumeActive.png'
import ResumeInactive from 'pages/pledgxOutputPDF/images/resumeInactive.png'
import ClickableImage from './clickableImage'

const borderColor = '#EBE9F1'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#EBE9F1',
        backgroundColor: '#F8F8F8',
        alignItems: 'center',
        height: 24,
        fontStyle: 'normal',
        paddingLeft: 15,
        color: '#000000',
        fontWeight: 400,
        fontSize: 10,
    },
    name: {
        width: '40%',
        textAlign: 'left',
        borderRightColor: borderColor,
    },
    position: {
        width: '30%',
        borderRightColor: borderColor,
        textAlign: 'left',
    },
    linkedIn: {
        width: '15%',
        borderRightColor: borderColor,
        textAlign: 'left',
    }, 
    resume: {
        width: '15%',
        borderRightColor: borderColor,
        textAlign: 'left',
    },
});

const PageTwoCompanyInfoTableRow = ({ items }) => {
    const rows = items?.map(item =>
        <View style={styles.row} key={item?.id.toString()}>
            <Text style={styles.name}>{item?.firstName} {item?.lastName}</Text>
            <Text style={styles.position}>{item?.position}</Text>
            <Text style={styles.linkedIn}>
                {item?.linkedInProfile !== "" ? <ClickableImage src={LinkedInActive} href={item?.linkedInProfile} /> : <Image src={LinkedInInactive} style={{ position: 'absolute', height: 12, width: 12 }} />}
            </Text>
            <Text style={styles.resume}>
                {item?.is_resume === true ? <Image src={ResumeActive} style={{ marginTop: 0, height: 16, width: 40 }} /> : <Image src={ResumeInactive} style={{ height: 16, width: 40 }} />}
            </Text>
        </View>
    );
    return (<Fragment>{rows}</Fragment>)
};

export default PageTwoCompanyInfoTableRow;
